export const hamburgerMenu = () => {
	const hamburgerMenuButton = document.getElementById( 'hamburger-menu-button' );

	if ( ! hamburgerMenuButton ) {
		return;
	}

	const toggleHamburgerButton = () => {
		const headerElement = document.querySelector( '.header' );

		if ( ! headerElement ) {
			return;
		}

		headerElement.classList.toggle( 'header--mobile-is-open' );
		document.body.classList.toggle( 'body--mobile-menu-is-open' );

		/**
		 * Dispatch a custom event to notify other js that the menu is open
		 * to avoid scroll being triggered straight after opening the menu causing
		 * the menu to close.
		 */
		window.dispatchEvent( new Event( 'newscientist-menu-open' ) );
	};

	hamburgerMenuButton?.addEventListener( 'click', () => {
		toggleHamburgerButton();
	} );
};

export default hamburgerMenu;
